module.exports = __webpack_public_path__ + "media/images/bg/shapes/cloud-red-7103a99d41551f8bde4965025f4483d0.svg";